import { Link, useNavigate } from "react-router-dom"
import React, { useEffect,useState } from 'react';
import NavBar from './WebPages/NavBar';
import { get_lastupdated_time } from "./Services/Service";

function Protected(props) {
    const [lastTime, setLastTime] = useState('');

    const { Component } = props;

    const nav = useNavigate();
    useEffect(() => {
        let isLoggedIn = localStorage.getItem('user');
        let programDetail= JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
        if (isLoggedIn <= 0) {
            return nav('/login');
        }

        if(programDetail == '0'){
            return nav('/program-list');
        }
        else if (Component.name == 'Login') {
            return  nav('/program-list');
        }
        
    
    }, []);

    useEffect(() => {
        get_lastupdated_time().then((res) => {
            if(res?.data?.code==200){
                setLastTime(res.data.data);            
            }
        });
    
    }, []);

    
    return (
        <div className="displayFlex">
            
            <div className="col-lg-3 col-xl-2">
                
                <NavBar />
            <section style={{zIndex:"99", width:"100%", float:"right", position:"fixed", bottom:"0"}} className=" mt-auto">
                <div style={{width:"83%",marginLeft:"17%", backgroundColor:"#eff4fd"}} className="container-fluid py-2">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/qur4n/73nutjmazs.png" style={{height:"42px"}} alt="" />
                        </div>
                        <div className="col-md-6">
                            <h6 style={{color: "#535f7e"}} className="text-end mb-0">
                                Last Updated : {lastTime} 
                            </h6>
                        </div>
                    </div>
                </div>
            </section>
            </div>

            <div className="col-lg-9 col-xl-10 d-flex flex-column position-relative mb-16">
                <Component />
            </div>

        </div>
    )
}

export default Protected;